module.exports = __webpack_public_path__ + "static/media/8_r_debalcevo_72.19_69.81.df780fc3.png";